<section class="bottom-nav">
    <!-- TO DO -->
</section>
